///////////////////////////////////////////////////////////////////////////////////////////////////brand_promos
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promo_performances = abcsetup.brand_promo_performances || {};
abcsetup.brand_promo_performances.common = abcsetup.brand_promo_performances.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.brand_promo_performances.common = {
    bindFormElems: function () {
    },

}